var map = {
	"./404.svg": 3854,
	"./address-line.svg": 33441,
	"./address-name.svg": 2670,
	"./address-phone.svg": 20529,
	"./balance.svg": 66918,
	"./benefits.svg": 31438,
	"./bug.svg": 12372,
	"./chart.svg": 6134,
	"./clipboard.svg": 81872,
	"./component.svg": 2767,
	"./dashboard.svg": 21778,
	"./documentation.svg": 74896,
	"./download.svg": 97418,
	"./drag.svg": 11264,
	"./edit.svg": 50742,
	"./education.svg": 81396,
	"./email.svg": 34126,
	"./example.svg": 28136,
	"./excel.svg": 14643,
	"./exit-fullscreen.svg": 58052,
	"./export.svg": 48492,
	"./eye-open.svg": 51346,
	"./eye.svg": 81613,
	"./facebook.svg": 23046,
	"./form.svg": 98096,
	"./fullscreen.svg": 95201,
	"./guide.svg": 93898,
	"./ic_down.svg": 14761,
	"./ic_search.svg": 31293,
	"./ic_up.svg": 98822,
	"./icon-delete.svg": 34111,
	"./icon-ic_screenshot.svg": 78269,
	"./icon.svg": 68561,
	"./icon_add.svg": 14829,
	"./icon_error.svg": 81646,
	"./icon_face.svg": 5455,
	"./international.svg": 32150,
	"./inventory.svg": 94574,
	"./language.svg": 83748,
	"./link.svg": 30618,
	"./list.svg": 41486,
	"./logo-mini.svg": 79321,
	"./logo.svg": 64243,
	"./logo1.svg": 92856,
	"./logout.svg": 66832,
	"./message.svg": 10271,
	"./method.svg": 77225,
	"./money.svg": 35010,
	"./nested.svg": 69075,
	"./note.svg": 56382,
	"./password.svg": 80473,
	"./pdf.svg": 38268,
	"./people.svg": 22511,
	"./peoples.svg": 64462,
	"./qq.svg": 45068,
	"./record.svg": 27425,
	"./search.svg": 24642,
	"./setting.svg": 34734,
	"./shopcart.svg": 63152,
	"./shopping.svg": 5246,
	"./size.svg": 88245,
	"./skill.svg": 26029,
	"./star.svg": 77298,
	"./subtract.svg": 54318,
	"./tab.svg": 72687,
	"./table.svg": 32982,
	"./theme.svg": 35245,
	"./tree-table.svg": 58253,
	"./tree.svg": 83270,
	"./triangle.svg": 13042,
	"./user.svg": 21779,
	"./wechat.svg": 56844,
	"./zip.svg": 93391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80256;